export const overlayPositionPortalClass = 'overlay-position-portal';
export const bodyOverlayPositionActiveClass = 'bodyOverlayPosition_active';
